import { useModal } from '@/hooks'
import { questionIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import Button from '../Button'
import Container from '../Container'
import style from './styles/have_questions_small.module.scss'

const HaveQuestionsSmall = (): React.ReactElement => {
  const { openModal } = useModal()

  const handleClick = (): void => {
    openModal('feedback')
  }
  return (
    <div className={style.ques}>
      <Container>
        <div className={style.ques_wrap}>
          <GxIcon src={questionIcon} className={style.ques__icon} />
          <div className={style.ques_flex}>
            <span className={style.ques__text}>Остались вопросы?</span>

            <Button
              size='large'
              theme='primary'
              highlight
              wide
              onClick={handleClick}
              className={style.ques__button}
            >
              Задать вопрос
            </Button>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default HaveQuestionsSmall
